import { Injectable } from '@angular/core';
import { ConnectionService } from './connection.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from './endpoint.config.service';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import * as payment from 'src/assets/js/PaymentWrapper/index.js';
import { environment } from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class ReceiptService extends ConnectionService {
  currentLocationId: any;
  constructor(http: HttpClient, private configs: ConfigService, private toaster: ToastrService) {
    super(http);

    if (this.currentLocationId == undefined && sessionStorage.getItem("company") != undefined)
      this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
  }

  getShipperTypes(sucFun){

        if (this.currentLocationId == undefined && sessionStorage.getItem("company") != undefined)
      this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
          var url = this.configs.getAppApiUrl("Get_Shipper_Type")+"/"+this.currentLocationId;
      this.CallApi("get", url, {}, null, (res) => {
      sucFun(res);
    }, (err) => {
      console.log("error => ",err);
    });
  }

  getReceiptTypes(sucFun, errFun) {
    this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    this.CallApi("get", this.configs.getAppApiUrl("GET_RECEIPT_TYPES").replace("{{currentLocationId}}", this.currentLocationId), {}, null, (res) => {
      sucFun(res);
    }, (err) => {
      errFun(err);
    });
  }

  getProductTypes(sucFun, errFun, productGroup, requestBody) {
    this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    var endPoint = this.configs.getAppApiUrl("GET_PRODUCT_TYPE").replace("{{currentLocationId}}", this.currentLocationId).replace("{{productGroup}}", productGroup);
    this.CallApi("get", endPoint, requestBody, null, (res) => {
      sucFun(res)
    }, (err) => {
      errFun(err)
    });
  }
  getServicesType(sucFun, errFun, productGroup, requestBody) {
    this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    var endPoint = this.configs.getAppApiUrl("GET_SERVICES_TYPE").replace("{{currentLocationId}}", this.currentLocationId).replace("{{productGroup}}", productGroup);
    this.CallApi("get", endPoint, requestBody, null, (res) => {
      sucFun(res)
    }, (err) => {
      errFun(err)
    });
  }

  getCommodities(sucFun, errFun) {
    this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    this.CallApi("get", this.configs.getAppApiUrl("COMMODITIES").replace("{{currentLocationId}}", this.currentLocationId), {}, null, (res) => {
      var initalList = res as any[];
      var commodities = [] as any[];
      for (var i = 0; i < initalList.length; i++) {
        commodities.push({ key: initalList[i].Description, value: initalList[i].CommodityId })
      }
      sucFun(commodities);
    }, (err) => {
      errFun(err);
    });
  }
  calculateItemChargeableWeight(productGroup, requestBody, sucFun, errFun) {
    this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    var endPoint = this.configs.getAppApiUrl("CALCULATE_WEIGHT").replace("{{currentLocationId}}", this.currentLocationId).replace("{{productGroup}}", productGroup);
    this.CallApi('post', endPoint, requestBody, null, (res) => {
      sucFun(res);
    }, (err) => {
      errFun(err);
    })
  }
  getAdditionalAmounts(sucFun, errFun) {
    this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    var endPoint = this.configs.getAppApiUrl("GET_ADDITIONAL_AMOUNTS").replace("{{currentLocationId}}", this.currentLocationId);
    this.CallApi("get", endPoint, {}, null, (res) => {
      sucFun(res);
    }, (err) => {
      errFun(err);
    });
  }
getShipmentDetails(AWB, ReceiptType, isInboundValidationOnDestEnabled, sucFun, errFun) {
    this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');

    var endPoint = this.configs.getAppApiUrl("GET_SHIPMENT_DETAILS")
        .replace("{{currentLocationId}}", this.currentLocationId)
        .replace("{{ReceiptType}}", ReceiptType)
        .replace("{{isInboundValidationOnDestEnabled}}", isInboundValidationOnDestEnabled);

    this.CallApi('post', endPoint, JSON.stringify(AWB),
        headers,
        (res) => {
            sucFun(res);
        }, 
        (err) => {
            errFun(err);
        });
}

  getDropOffShipmentDetails(AWB, ReceiptType, sucFun, errFun) {
    this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    var endPoint = this.configs.getAppApiUrl("GET_DROP_OFF_SHIPMENT_DETAILS").replace("{{currentLocationId}}", this.currentLocationId).replace("{{ReceiptType}}", ReceiptType);
    this.CallApi('post', endPoint, JSON.stringify(AWB),
      headers
      , (res) => {
        sucFun(res);
      }, (err) => {
        errFun(err);
      });
  }

    getDropOffRTIShipmentDetails(AWB, ReceiptType, sucFun, errFun) {
    this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    var endPoint = this.configs.getAppApiUrl("GET_DROP_OFF_RTI_SHIPMENT_DETAILS").replace("{{currentLocationId}}", this.currentLocationId).replace("{{ReceiptType}}", ReceiptType);
    this.CallApi('post', endPoint, JSON.stringify(AWB),
      headers
      , (res) => {
        sucFun(res);
      }, (err) => {
        errFun(err);
      });
  }

  getReceiptSubTypes(receiptType, sucFun, errFun) {
    this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    this.CallApi("get", this.configs.getAppApiUrl("GET_RECEIPT_SUB_TYPES").replace("{{currentLocationId}}", this.currentLocationId).replace("{{ReceiptType}}", receiptType), {}, null, (res) => {
      sucFun(res);
    }, (err) => {
      errFun(err);
    });
  }
  getArrowable(productGroup): Observable<any> {
    this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    var arrowableObj = new Subject();
    var arrowable = arrowableObj as Observable<any>
    this.CallApi("get", this.configs.getAppApiUrl("GENERATE_ARRAOWABLE").replace("{{currentLocationId}}", this.currentLocationId).replace("{{productGroup}}", productGroup), {}, null, (res) => {
      arrowableObj.next(res);
    }, (err) => {
      arrowableObj.next(err);
    });
    return arrowable;
  }
  calculateRate(requestBody, sucFun, errFun) {
    this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    this.CallApi('post', this.configs.getAppApiUrl("CALCULATE_RATE").replace("{{currentLocationId}}", this.currentLocationId), requestBody, null, (res) => {
      sucFun(res);
      // console.log(this.configs)
    }, (err) => {
      try {
        errFun(err);
      }
      finally {
        // console.log(err ,this.configs )

      }
    })
  }

  generateCommercialInvoice(requestBody, sucFun, errFun) {
    this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    this.CallApi('post', this.configs.getAppApiUrl("GENERATE_COMM_INVOICE").replace("{{currentLocationId}}", this.currentLocationId), requestBody, null, (res) => {
      sucFun(res);
    }, (err) => {
      try {
        errFun(err);
      }
      finally {
      }
    })
  }

  calculateDropOffRate(requestBody, sucFun, errFun) {
    this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    this.CallApi('post', this.configs.getAppApiUrl("CALCULATE_NEW_DROP_OFF_RATE").replace("{{currentLocationId}}", this.currentLocationId), requestBody, null, (res) => {
      sucFun(res);
    }, (err) => {
      try {
        errFun(err);
      }
      finally {
      }
    })
  }

  searchReceipt(requestBody, sucFun, errFun) {
    this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    this.CallApi("get", this.configs.getAppApiUrl("SEARCH_RECEIPT").replace("{{currentLocationId}}", this.currentLocationId), requestBody, null, (res) => {
      sucFun(res);
    }, (err) => {
      errFun(err);
    });
  }

  checkout(requestBody, sucFun, errFun) {
    this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    console.log("requestBody",requestBody);
    this.CallApi("post", this.configs.getAppApiUrl("CHECKOUT").replace("{{currentLocationId}}", this.currentLocationId), requestBody, null, (res) => {
      sucFun(res);
    }, (err) => {
      errFun(err);
    })
  }

  LinkShipment(requestBody, sucFun, errFun) {
    this.CallApi("post", this.configs.getAppApiUrl("LinkShipment"), requestBody, null, (res) => {
      sucFun(res);
    }, (err) => {
      errFun(err);
    })
  }


  cancelShipment(receiptObj, sucFun, errFun) {
    this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    this.CallApi("post", this.configs.getAppApiUrl("CANCEL_SHIPMENT").replace("{{currentLocationId}}", this.currentLocationId).replace("{{receiptId}}", receiptObj.ReceiptId).replace("{{shipmentId}}", receiptObj.ShipmentId), {}, null, (res) => {
      sucFun(res);
    }, (err) => {
      errFun(err);
    });
  }

  getCashOutReceipt(request, sucFun, errFun) {
    this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    this.CallApi('get', this.configs.getAppApiUrl('GET_RECEIPT_CHASHOUT').replace("{{currentLocationId}}", this.currentLocationId), request, null,
      (res) => {
        var resp = JSON.parse(JSON.stringify(res));

        sucFun(resp)
      },
      (err) => {
        try {
          errFun(err);
        }
        catch (e) {

        }
      })
  }

  getCashOutReceiptByCurrency(request, sucFun, errFun) {
    this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    this.CallApi('get', this.configs.getAppApiUrl('GET_RECEIPT_INIT_CASHOUT').replace("{{currentLocationId}}", this.currentLocationId), request, null,
      (res) => {
        var resp = JSON.parse(JSON.stringify(res));

        sucFun(resp)
      },
      (err) => {
        try {
          errFun(err);
        }
        catch (e) {

        }
      })
  }

  getCreditCardTypes(sucFun, errFun) {
    this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    this.CallApi('get', this.configs.getAppApiUrl('GET_CREDIT_CARD_TYPES').replace("{{currentLocationId}}", this.currentLocationId), {}, null,
      (res) => {
        sucFun(res)
      },
      (err) => {
        try {
          errFun(err);
        }
        catch (e) {

        }
      })
  }


  performCashOutReceipt(sucFun, errFun) {
    this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    this.CallApi('post', this.configs.getAppApiUrl('CASH_OUT').replace("{{currentLocationId}}", this.currentLocationId), {}, null, (res) => {
      sucFun(res)
    }, (err) => {
      try {
        errFun(err)
      }
      catch (ex) {
      }
    })
  }
  uploadReceiptAttachment(receiptId, attachmentType, ReceiptTypeId, param, sucFun, errFun) {
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json')
    this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    var endPoint = this.configs.getAppApiUrl('UPLOAD_FILE')
      .replace('{{currentLocationId}}', this.currentLocationId)
      .replace('{{receiptId}}', receiptId)
      .replace('{{attachmentType}}', attachmentType)
      .replace('{{typeId}}', ReceiptTypeId)
    this.CallApi("post", endPoint, param, headers, (res) => {
      sucFun(res)
    }, (err) => {
      try {
        errFun(err)
      }
      finally {
      }
    })
  }


  printWaybillAndReceipt(receiptId, sucFun, errFun, type) {

    this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    var endPoint = this.configs.getAppApiUrl("PRINT_RECEIPT_Waybill_SHIPPMENTS")
      .replace("{{currentLocationId}}", this.currentLocationId)
      .replace("{{receiptId}}", receiptId)
    this.CallApi('get', endPoint, null, null, (res) => {
      console.log("this.CallApi", res);
      console.log("endPoint", endPoint);
      sucFun(res)
    }, (err) => {
      try {
        errFun(err)
      }
      finally {
      }
    })
  }
  printReceiptShipment(receiptId, shipmentId, sucFun, errFun) {
    this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    var endPoint = this.configs.getAppApiUrl("PRINT_RECEIPT_SHIPPMENTS")
      .replace("{{currentLocationId}}", this.currentLocationId)
      .replace("{{receiptId}}", receiptId)
      .replace("{{shipmentId}}", shipmentId)

    this.CallApi('get', endPoint, null, null, (res) => {
      sucFun(res)
    }, (err) => {
      try {
        errFun(err)
      }
      finally {
      }
    })

  }
  printCashout(receiptId, sucFun, errFun) {
    this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    var endPoint = this.configs.getAppApiUrl("PRINT_CASHOUT")
      .replace("{{currentLocationId}}", this.currentLocationId)
      .replace("{{receiptId}}", receiptId)
    this.CallApi('get', endPoint, null, null, (res) => {
      sucFun(res)
    }, (err) => {
      try {
        errFun(err)
      }
      finally {
      }
    })
  }

  uploadReceiptInvoice(receiptId, shipmentId, param, sucFun, errFun) {
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json')
    this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    var endPoint = this.configs.getAppApiUrl('UPLOAD_INVOICE')
      .replace('{{currentLocationId}}', this.currentLocationId)
      .replace('{{receiptId}}', receiptId)
      .replace('{{shipmentId}}', shipmentId)
    this.CallApi("post", endPoint, param, headers, (res) => {
      sucFun(res)
    }, (err) => {
      try {
        errFun(err)
      }
      finally {

      }
    })
  }

  getPaymentDeviceInfo(sucFun, errFun) {
     
    var currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    var endPoint = this.configs.getAppApiUrl("GET_PAYMENT_DEVICES").replace('{{currentLocationId}}', currentLocationId);
    var currentPaymentDevice = JSON.parse(sessionStorage.getItem("user")).Settings.PaymentDeviceCode;
    if (currentPaymentDevice)
      endPoint = endPoint + '/' + currentPaymentDevice;
    this.CallApi("get", endPoint, {}, null, (res) => {
      console.log("getPaymentDeviceInfo response"+res);
      sucFun(res);

    }, (err) => {
      console.log('err in receipt service');
      console.log(err);
      errFun(err)
    });

  }
  loadDGSecureScript(script) {
    payment.paymentWrapper.appendScript(environment.DGSecure)
  }

  integrateWithPayment(code, amount, currency, terminal, sucFun, errFun) {

    console.log("\nCode: "+code+" terminal: "+terminal+"\n");
    if(code == "DG03" || code === "DG03"){
      this.integrateWithPaymentArabBank(amount, currency, sucFun, errFun);
      return;
    }
    var currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    var endPoint = this.configs.getAppApiUrl("PAY_WITH_PAYMENT_DEVICE").replace('{{currentLocationId}}', currentLocationId);

    var requestObj = {
      code: code,
      amount: amount,
      currency: currency,
      terminal:terminal
    };

    this.CallApi("post", endPoint, requestObj, null,
      (res) => {
        sucFun(res)
      },
      (err) => {
        errFun(err)
      })

  }

  integrateWithPaymentArabBank(amount, currency,sucFun, errFun){
    console.log("integrateWithPaymentArabBank");
    var IndexCode = this.generateTransIndexCode(16);
    var token = sessionStorage.getItem('username');
    window.open("outletarabbank://Purchase/"+amount+"/"+IndexCode+"/"+token,'_blank');
    var count =0 ;
    setTimeout(() => {
      this.checkForResponse(IndexCode,4,sucFun, errFun);
    }, 20000);
   
    setInterval(() =>{
      if(count < 4){
        this.checkForResponse(IndexCode,count,sucFun, errFun)
        count++;
      }
    
    }
    , 10000);
  }

  checkForResponse(indexCode,count,sucFun, errFun){
     var endPoint = this.configs.getAppApiUrl("Get_ArabBank_Payment")+indexCode;
     var respon = "";

     this.CallApi("get", endPoint,null, null,
      (res) => {
        if(res == "" || !res){
          return
        }

        sucFun(res)
      },
      (err) => {  
        if(count >3){
          errFun(err)
        }       
      })

  }



  generateTransIndexCode(length) {
    var result  = '';
    var characters  = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
}

  SmartResendPin(smartObj, sucFun, errFun) {
    var currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    var endPoint = this.configs.getAppApiUrl("SMART_RESEND_PIN").replace('{{currentLocationId}}', currentLocationId);
    this.CallApi("post", endPoint, smartObj, null,
      (res) => {
        sucFun(res)
      },
      (err) => {
        errFun(err)
      })

  }
  
  validateSmartPinNumber(smartObj, sucFun, errFun) {
    var currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    var endPoint = this.configs.getAppApiUrl("SMART_VALIDATE_PIN").replace('{{currentLocationId}}', currentLocationId);
    this.CallApi("post", endPoint, smartObj, null,
      (res) => {
        sucFun(res)
      },
      (err) => {
        errFun(err)
      })
  }

}
